export default {
  root: {
    paddingTop: 4,
    paddingBottom: 4,
    '& > .MuiListItem-divider:last-child': {
      borderBottom: 'none',
    },
  },
};
